import { METHODS, request } from '../axiosInstances';

export default {
  getHistoryOptions: (params = {}) => request(METHODS.GET, `/review/history/options/`, { params }),
  get: (params = {}) => request(METHODS.GET, `/review/actions/`, { params }),
  create: (params: Record<string, unknown>) =>
    request(METHODS.POST, `/review/actions/`, { params }),
  update: (params: Record<string, unknown>) =>
    request(METHODS.PUT, `/review/actions/status/`, { params }),
  delete: (payload: Record<string, unknown>) =>
    request(METHODS.DELETE, `/review/actions/`, { payload }),
};
